import React from 'react';
import {
	fade,
	makeStyles,
	Theme,
	createStyles,
} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		grow: {
			flexGrow: 1,
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		title: {
			display: 'none',
			[theme.breakpoints.up('sm')]: {
				display: 'block',
			},
		},
		search: {
			position: 'relative',
			borderRadius: theme.shape.borderRadius,
			backgroundColor: fade(theme.palette.common.white, 0.15),
			'&:hover': {
				backgroundColor: fade(theme.palette.common.white, 0.25),
			},
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			flex: "100%",
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(3),
				width: 'auto',
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: '100%',
			position: 'absolute',
			pointerEvents: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		inputRoot: {
			color: 'inherit',
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create('width'),
			width: '100%',
			[theme.breakpoints.up('md')]: {
				width: '20ch',
			},
		},
		sectionMobile: {
			display: 'flex',
			[theme.breakpoints.up('md')]: {
				display: 'none',
			},
		},
		root: {

		}
	})
);

export type SearchBarProps = {
	onSearch: any;
	items: any[];
	name: string
};

const SearchBar = (props: SearchBarProps) => {
	const classes = useStyles();

	return (
		<div className={classes.grow}>
			<AppBar color='transparent' position='static'>
				<Toolbar>
					{/* <Grid container spacing={4} className={classes.root}>
						<Grid item xs={9} direction='column'> */}
							<Box className={classes.search}>
								<Box className={classes.searchIcon}>
									<SearchIcon />
								</Box>
								<InputBase
									placeholder='Search…'
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
									inputProps={{ 'aria-label': 'search' }}
								/>
							</Box>
						{/* </Grid>
						<Grid item xs={2} direction='column'>
							{/* <SubmitButton
								icon={<AddIcon />}
								message={`Create a new ${props.name.substring(0,  props.name.length - 1)}`}
								onClick={handleCreateNewItem}
								className={classes.createItemButton}
							/> */}
							{/* <PopUpForm form={<CreateInvestigation />} popupButtonTitle={`Create a new ${props.name.substring(0, props.name.length - 1)}`} /> */}
						{/* </Grid> */} 
					{/* </Grid> */}
				</Toolbar>
			</AppBar>
		</div>
	);
};

export default SearchBar;
